
import { useState } from 'react';
import { OnActiveProjectSubscriptionChangedFunction, SendLogFunction } from 'functions/functionDeclarations';
import DataSetOperators, { SortDirection } from 'interfaces/DataSetOperators';
import DataWrapper from 'interfaces/DataWrapper';
import { FeatureLimitation } from 'models/FeatureLimitation';
import { LogLevel } from 'models/LogLevel';

import { Entities } from '../models/Entities';
import { Project } from '../models/Project';

import { useDataSet } from './useDataSet';
import { useLocalStorage } from './useLocalStorage';
import { useSubscriptionManager } from './useSubscriptionManager';



export const useProjectRepo = (apiBaseUrl: string, sendLog: SendLogFunction, subscriptionApiUrl: string, onTokenExpired: any, onActiveProjectSubscriptionChanged: OnActiveProjectSubscriptionChangedFunction) => {
  const initialQueryParams: DataSetOperators = {
    Top: 100,
    Skip: 0,
    SortBy: "id",
    SortDirection: SortDirection.Asc
  };
  const { dataSet, setOperators } = useDataSet<Project>(apiBaseUrl, Entities.Projects, undefined, initialQueryParams);
  const projects = (dataSet.responseData as DataWrapper<Project>)?.data ?? [];
  const [featureLimitations, setFeatureLimitations] = useState<FeatureLimitation[]>([]);

  const subscriptionHandler = useSubscriptionManager(
    subscriptionApiUrl,
    sendLog,
    onTokenExpired,
    onActiveProjectSubscriptionChanged,
    Entities.Subscriptions,
  );

  const [selectedProjectId, setLocalStorageSelectedProjectId] = useLocalStorage<number>(
    sendLog,
    'selectedProjectId',
    undefined,
  );

  const setSelectedProjectIdAsync = async (projectId: number | undefined) => {
    setLocalStorageSelectedProjectId(projectId);

    if (!projectId) {
      sendLog(`Selected project id set to 'undefined.'  Can't apply subscription feature limits`, LogLevel.warn);
      return;
    }

    const selectedProject = projects.find(p => p.id === projectId);
    if (!selectedProject) {
      sendLog(`INVALID selected project id ${projectId}, reloading projects`, LogLevel.warn);
      setOperators(initialQueryParams);
      return;
    }

    try {
      const featureLimits = await subscriptionHandler.getSubscriptionFeatureLimitations(selectedProject!.companyId);
      setFeatureLimitations(featureLimits);
    } catch (e) {
      const defaultLimits: FeatureLimitation[] = [];
      setFeatureLimitations(defaultLimits);
    }

  }

  return { projects, selectedProjectId, setSelectedProjectIdAsync, featureLimitations };
};
